// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"styles_modalBackdrop__oPLYE","modal":"styles_modal__Ctjx4","actions":"styles_actions__wKwgU","deleteButton":"styles_deleteButton__JCwlm"};